export default __webpack_public_path__ + "static/mac-cc-97ec199b48447ba6d9f55d3f759c4c66.webm";